import React from 'react';
import MediaAsset from '../mediaAsset/MediaAsset';
import './ThankYouSection.css';

function ThankYouSection({ image, thankYouText = ["Thank you for spending time with us.", "The first hours of our married life."] }) {
  return (
    <div className="thank-you-section">
      <div className="circular-photo">
        <MediaAsset src={image} heightPercent={33} shiftPercent={80} />
      </div>
      <p className="thank-you-text">
        {thankYouText.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < thankYouText.length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
    </div>
  );
}

export default ThankYouSection; 